var filterVersion=function(a){return a?a.replace(/[^0-9.\-a-z]/g,""):void 0},getVersion=function(a,b){return a&&(a.dependencies||a.devDependencies)?a.devDependencies&&a.devDependencies[b]?filterVersion(a.devDependencies[b]):filterVersion(a.dependencies[b]):void 0};var versionHelper = {getVersion:getVersion};

export { versionHelper };
